import { Styles } from '@monkvision/types';

export const styles: Styles = {
  vehicleSurroundingsSvg: {
    width: '100%',
    height: 'auto',
  },
};
